/**
 * Temporary diagnostics for `/event/:id` issues on production.
 *
 * Enable (pick one):
 *   - Append `?debugEvents=1` to any URL once and reload — we persist in sessionStorage.
 *   - Or in the console: `sessionStorage.setItem('ummahfyDebugEvents','1')` then reload.
 *   - Or build with `REACT_APP_DEBUG_EVENT_SHELL=true`.
 *
 * Remove this module once the incident is fully resolved (search: ummahfyDebugEvents).
 */

export function initEventShellDebugFromUrl() {
  if (typeof window === "undefined") return;
  try {
    if (/[?&]debugEvents=1(?:&|$)/.test(window.location.search)) {
      window.sessionStorage.setItem("ummahfyDebugEvents", "1");
      console.warn(
        "[Ummahfy EventShell] debug logging ENABLED (sessionStorage ummahfyDebugEvents)",
      );
    }
  } catch (_) {
    /* ignore private mode errors */
  }
}

export function isEventShellDebugEnabled() {
  if (typeof window === "undefined") return false;
  try {
    if (process.env.REACT_APP_DEBUG_EVENT_SHELL === "true") return true;
    return window.sessionStorage?.getItem("ummahfyDebugEvents") === "1";
  } catch (_) {
    return false;
  }
}

export function logEventShell(stage, payload) {
  if (!isEventShellDebugEnabled()) return;
  console.log("[Ummahfy EventShell]", new Date().toISOString(), stage, payload);
}
